import {
    LogoutOutlined,
    UsergroupAddOutlined,
    ApartmentOutlined,
    ReloadOutlined,
    ShopOutlined,
    ExportOutlined,
    ClockCircleOutlined,
    SyncOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    MinusCircleOutlined,
    ImportOutlined,
    CalendarOutlined,
    DashboardOutlined,
    HourglassOutlined,
    FormOutlined,
    SettingOutlined,
    UserAddOutlined,
    TeamOutlined,
    FileTextOutlined,
    DollarOutlined,
    MenuOutlined,
    BarsOutlined,
    BranchesOutlined,
    CarryOutFilled,
    ContainerOutlined,
    DownloadOutlined,
    AppstoreAddOutlined,
    CustomerServiceOutlined,
    FieldTimeOutlined
} from '@ant-design/icons';

export const DATE_FORMAT = {
    DDMMYYYY_FORMAT: "DD/MM/YYYY",
    YYYYMMDD_FORMAT: "YYYY-MM-DD",
    DDMM_FORMAT: "DD/MM",
    DD_MM_YYYY_FORMAT: "DD-MM-YYYY",
    YYYYMMDDHHMMSS_FORMAT: "YYYY-MM-DD HH:mm:ss",
    YYYYMMDDHHMMSS_FORMAT_2: "YYYY/MM/DD HH:mm:ss",
}

export const TYPE_MODAL = {
    ADD: "ADD",
    EDIT: "EDIT",
    DEL: "DEL",
    APPROVE: "APPROVE"
}

export const PASSWORD_DEFAULT = '123456asdfwer3';

export const LIST_MENU_SIDE_BAR = [
    {
        key: 'dashboard',
        path: "/dashboard",
        label: 'Thống kê tổng quan',
        icon: <DashboardOutlined />,
        permission: [1,2,3]
    },
    {
        key: 'dang-ky-dich-vu',
        path: "/dang-ky-dich-vu",
        label: 'Đăng ký dịch vụ',
        icon: <FormOutlined />,
        permission: [1,2,3]
    },
    {
        label: 'Chăm sóc khách hàng',
        icon: <CustomerServiceOutlined />,
        children: [
            {
                key: 'khach-hang-can-cham-soc',
                path: "/khach-hang-can-cham-soc",
                label: 'Chăm sóc khách hàng',
                icon: <CustomerServiceOutlined />,
                permission: [1,2,3]
            },
            {
                key: 'lich-su-cham-soc',
                path: "/lich-su-cham-soc",
                label: 'Lịch sử CSKH',
                icon: <FieldTimeOutlined />,
                permission: [1,2,3]
            },
            {
                key: 'lich-su-su-dung-dich-vu',
                path: "/lich-su-su-dung-dich-vu",
                label: 'Lịch sử SD dịch vụ',
                icon: <FieldTimeOutlined />,
                permission: [1,2,3]
            },
            {
                key: 'cong-no-khach-hang',
                path: "/cong-no-khach-hang",
                label: 'Công nợ khách hàng',
                icon: <DollarOutlined />,
                permission: [1,2,3]
            },
        ]
    },
    
    {
        label: 'Quản lý hệ thống',
        icon: <SettingOutlined />,
        children: [
            {
                key: 'thong-tin-khach-hang',
                path: "/thong-tin-khach-hang",
                label: 'Khách hàng',
                icon: <UsergroupAddOutlined />,
                permission: [1,2,3]
            },
            // {
            //     key: 'import-khach-hang',
            //     path: "/import-khach-hang",
            //     label: 'Import khách hàng',
            //     icon: <ImportOutlined />,
            //     permission: [1,2,3]
            // },
            {
                key: 'chi-nhanh',
                path: "/chi-nhanh",
                label: 'Chi nhánh',
                icon: <ApartmentOutlined />,
                permission: [1]
            },
            {
                key: 'account',
                path: "/account",
                label: 'Tài khoản truy cập',
                icon: <UserAddOutlined />,
                permission: [1]
            },
            {
                key: 'employees',
                path: "/employees",
                label: 'Danh sách nhân viên',
                icon: <TeamOutlined />,
                permission: [1, 2]
            },
            {
                key: 'salary',
                path: "/salary",
                label: 'Quản lý tiền lương',
                icon: <DollarOutlined />,
                permission: [1, 2]
            },
        ]
    },
    {
        label: 'Quản lý kho',
        icon: <ShopOutlined />,
        children: [
            {
                key: 'danh-sach-kho',
                path: "/danh-sach-kho",
                label: 'Danh sách kho',
                icon: <ShopOutlined />,
                permission: [1,2]
            },
            {
                key: 'xuat-hang',
                path: "/xuat-hang",
                label: 'Xuất hàng',
                icon: <ExportOutlined />,
                permission: [1,2,3]
            },
            {
                key: 'nhap-hang',
                path: "/nhap-hang",
                label: 'Nhập hàng',
                icon: <ImportOutlined />,
                permission: [1,2,3]
            },
            {
                key: 'nhap-du-dau-ky',
                path: "/nhap-du-dau-ky",
                label: 'Nhập dư đầu kỳ',
                icon: <DownloadOutlined />,
                permission: [1,2]
            },
            
        ]
    },
    {
        label: 'Danh mục hệ thống',
        icon: <MenuOutlined />,
        children: [
            {
                key: 'danh-muc-dich-vu',
                path: "/danh-muc-dich-vu",
                label: 'Dịch vụ',
                icon: <BarsOutlined />,
                permission: [1]
            },
            // {
            //     key: 'import-danh-muc-dich-vu',
            //     path: "/import-danh-muc-dich-vu",
            //     label: 'Import dịch vụ',
            //     icon: <AppstoreAddOutlined />,
            //     permission: [1]
            // },
            {
                key: 'danh-muc-san-pham',
                path: "/danh-muc-san-pham",
                label: 'Sản phẩm',
                icon: <AppstoreAddOutlined />,
                permission: [1]
            },
            // {
            //     key: 'import-danh-muc-san-pham',
            //     path: "/import-danh-muc-san-pham",
            //     label: 'Import sản phẩm',
            //     icon: <AppstoreAddOutlined />,
            //     permission: [1]
            // },
            {
                key: 'danh-muc-chuc-vu',
                path: "/danh-muc-chuc-vu",
                label: 'Chức vụ',
                icon: <BranchesOutlined />,
                permission: [1]
            },
            {
                key: 'cong-tua',
                path: "/cong-tua",
                label: 'Công tua',
                icon: <CarryOutFilled />,
                permission: [1]
            },
            
        ]
    },
    
    {
        label: 'Báo cáo',
        icon: <ContainerOutlined />,
        children: [
            {
                key: 'bao-cao-ton-kho',
                path: "/bao-cao-ton-kho",
                label: 'Báo cáo tồn kho',
                icon: <FileTextOutlined />,
                permission: [1, 2, 3]
            },
            {
                key: 'bao-cao-xntk',
                path: "/bao-cao-xntk",
                label: 'Báo cáo XNTK',
                icon: <FileTextOutlined />,
                permission: [1, 2, 3]
            },
            {
                key: 'thong-ke-cong-tua',
                path: "/thong-ke-cong-tua",
                label: 'Thống kê công tua',
                icon: <FileTextOutlined />,
                permission: [1, 2, 3]
            },
            {
                key: 'hoa-hong-tu-van-vien',
                path: "/hoa-hong-tu-van-vien",
                label: 'Hoa hồng tư vấn viên',
                icon: <FileTextOutlined />,
                permission: [1, 2, 3]
            },
            {
                key: 'chi-tiet-tu-van-dich-vu',
                path: "/chi-tiet-tu-van-dich-vu",
                label: 'Chi tiết tư vấn dịch vụ',
                icon: <FileTextOutlined />,
                permission: [1, 2, 3]
            },
            {
                key: 'chi-tiet-tu-van-san-pham',
                path: "/chi-tiet-tu-van-san-pham",
                label: 'Chi tiết tư vấn sản phẩm',
                icon: <FileTextOutlined />,
                permission: [1, 2, 3]
            },
        ]
    },
    
    {
        key: 'doi-mat-khau',
        path: "/doi-mat-khau",
        label: 'Đổi mật khẩu',
        icon: <ReloadOutlined />,
        permission: [1, 2, 3, 4, 5]
    },
    {
        key: 'dang-xuat',
        path: "/dang-xuat",
        label: 'Đăng xuất',
        icon: <LogoutOutlined />,
        permission: [1, 2, 3, 4, 5, 6]
    },

];

export const requiredItem = [
    {
        required: true,
        message: 'Vui lòng không để trống'
    }
];


export const FORMAT_DATE = {
    YYYYMMDDHHMMSS: 'YYYY-MM-DD HH:mm:ss',
    YYYYMMDD: 'YYYY-MM-DD',
    DDMMYYYY: 'DD/MM/YYYY',
    DDMMYYYYHHMMSS: 'DD/MM/YYYY HH:mm:ss',
    MMYYYY: 'MM/YYYY',
}

export const STATUS_ORDER = [
    {
        value: 'waiting',
        label: 'Waiting',
        type: [1]
    },
    {
        value: 'processing',
        label: 'Processing',
        type: [1]
    },
    {
        value: 'completed',
        label: 'Completed',
        type: [1]
    },
    {
        value: 'cancelled',
        label: 'Cancelled',
        type: [1]
    },
    
    
]
export const STATUS_COMMON_NAME = {
    supplier: "Cancelled",
    staff: "Cancelled by supplier",
} 
export const statusOrderMap = {
    // waiting: { icon: <ClockCircleOutlined spin />, color: "#b81c24", text: "Waiting" },
    waiting: { icon: <HourglassOutlined />, color: "#f6941c", text: "Waiting" },
    updating: { icon: <SyncOutlined />, color: "processing", text: "Updating" },
    processing: { icon: <SyncOutlined />, color: "processing", text: "Processing" },
    picked: { icon: <ExportOutlined />, color: "processing", text: "picked" },
    fullfillment: { icon: <CheckCircleOutlined />, color: "success", text: "Fullfillment" },
    hold: { icon: <CloseCircleOutlined />, color: "error", text: "Hold" },
    cancelled: { icon: <CloseCircleOutlined />, color: "error", text: "Cancel" },
    refund: { icon: <CloseCircleOutlined />, color: "error", text: "Refund" },
    resend: { icon: <CloseCircleOutlined />, color: "processing", text: "Resend" },
    shipping: { icon: <MinusCircleOutlined />, color: "processing", text: "Shipping" },
    delivered: { icon: <CheckCircleOutlined />, color: "success", text: "Delivered" },
    completed: { icon: <CheckCircleOutlined />, color: "success", text: "Completed" },
    failed_delivery: { icon: <CloseCircleOutlined />, color: "error", text: "Failed Delivery" },
    cancel_common: { icon: <CloseCircleOutlined />, color: "error", text: "Canceled" },
};

export const STATUS_TASK = [
    {
        value: 'pending',
        label: 'Pending Assignment'
    },
    {
        value: 'waiting',
        label: 'Waiting Processing'
    },
    {
        value: 'processing',
        label: 'Processing'
    },
    {
        value: 'completed',
        label: 'Finished'
    },
    {
        value: 'cancelled',
        label: 'Cancelled'
    }
]

export const TYPE_EXPORT_TRACKING = [
    {
        value: 1,
        label: 'Have tracking number'
    },
    {
        value: 2,
        label: 'No tracking number'
    }
]

export const TYPE_TIME = [
    {
        value: 2,
        label: 'Export at'
    },
    {
        value: 1,
        label: 'Create at'
    }
]

export const PAGE_SIZE = [
    {
        value: 20,
        label: 20
    },
    {
        value: 30,
        label: 30
    },
    {
        value: 50,
        label: 50
    },
    {
        value: 70,
        label: 70
    },
    {
        value: 100,
        label: 100
    }
]

export const ROLE_PERMISSION = {
    ADMIN: "1",
    STAFF: "2",
}

export const STATUS_SHIPPING = [
    {
        value: 'transit',
        label: 'In Transit'
    },
    {
        value: 'pickup',
        label: 'Out for Delivery'
    },
    {
        value: 'undelivered',
        label: 'Failed Attempt'
    },
    {
        value: 'delivered',
        label: 'Delivered'
    },
    {
        value: 'exception',
        label: 'Exception'
    },
    {
        value: 'expired',
        label: 'Expired'
    },
    {
        value: 'notfound',
        label: 'Not Found'
    },
    {
        value: 'pending',
        label: 'Pending'
    }
]

export const OPTION_TIME = [
    {
        label: 'Hôm nay',
        value: 1,
        icon: <ClockCircleOutlined />,
    },
    {
        label: 'Hôm qua',
        value: 2,
        icon: <CalendarOutlined />,
    },
    {
        label: '7 ngày qua',
        value: 3,
        icon: <CalendarOutlined />,
    },
    {
        label: 'Tháng này',
        value: 4,
        icon: <CalendarOutlined />,
    },
    {
        label: 'Tháng trước',
        value: 5,
        icon: <CalendarOutlined />,
    },
]

export const LIST_MONTH = [
    {
        label: 'Tháng 1',
        value: 1,
    },
    {
        label: 'Tháng 2',
        value: 2,
    },
    {
        label: 'Tháng 3',
        value: 3,
    },
    {
        label: 'Tháng 4',
        value: 4,
    },
    {
        label: 'Tháng 5',
        value: 5,
    },
    {
        label: 'Tháng 6',
        value: 6,
    },
    {
        label: 'Tháng 7',
        value: 7,
    },
    {
        label: 'Tháng 8',
        value: 8,
    },
    {
        label: 'Tháng 9',
        value: 9,
    },
    {
        label: 'Tháng 10',
        value: 10,
    },
    {
        label: 'Tháng 11',
        value: 11,
    },
    {
        label: 'Tháng 12',
        value: 12,
    },
]

export const TYPE_LOG_TASK = {
    EDIT_END_TIME: 'end_time',
    EDIT_COMPLETED_AT: 'completed_time',
}

export const HeaderTableCus = {
    header: {
        cell: (props) => (
            <th
                {...props}
                style={{
                    backgroundColor: '#1890ff', // Màu nền
                    color: '#fff', // Màu chữ
                    textAlign: 'center', // Căn giữa
                    fontWeight: 'bold', // Đậm chữ
                    fontSize: 14, // Kích thước chữ
                    height: 16, // Chiều cao của header (giảm xuống)
                    lineHeight: '20px', // Dòng chữ căn chỉnh theo chiều cao
                    padding: '8px 8px',
                    whiteSpace: 'normal', // Cho phép xuống dòng
                    wordWrap: 'break-word', // Cho phép xuống dòng,
                    borderRadius: '0'
                }}
            >
                {props.children}
            </th>
        ),
    },
};

export const HeaderTableChildCus = {
    header: {
        cell: (props) => (
            <th
                {...props}
                style={{
                    backgroundColor: '#5e94c6', // Màu nền
                    color: '#fff', // Màu chữ
                    textAlign: 'center', // Căn giữa
                    fontSize: 13, // Kích thước chữ
                    height: 20, // Chiều cao của header (giảm xuống)
                    lineHeight: '20px', // Dòng chữ căn chỉnh theo chiều cao
                    padding: '8px 4px',
                    whiteSpace: 'normal', // Cho phép xuống dòng
                    wordWrap: 'break-word', // Cho phép xuống dòng,
                    borderRadius: '0'
                }}
            >
                {props.children}
            </th>
        ),
    },
};

export const HeaderTableChildCusL3 = {
    header: {
        cell: (props) => (
            <th
                {...props}
                style={{
                    backgroundColor: '#7cd1c4', // Màu nền
                    color: '#000', // Màu chữ
                    textAlign: 'center', // Căn giữa
                    fontSize: 13, // Kích thước chữ
                    height: 20, // Chiều cao của header (giảm xuống)
                    lineHeight: '20px', // Dòng chữ căn chỉnh theo chiều cao
                    padding: '8px 4px',
                    whiteSpace: 'normal', // Cho phép xuống dòng
                    wordWrap: 'break-word', // Cho phép xuống dòng,
                    borderRadius: '0'
                }}
            >
                {props.children}
            </th>
        ),
    },
};

export const TYPE_COMMISSION = [
    {
        value: 'percent',
        label: '%'
    },
    {
        value: 'fixed',
        label: 'Số tiền'
    }
]

export const TYPE_TICKET = [
    {
        value: 'daily',
        label: 'Buổi'
    },
    {
        value: 'monthly',
        label: 'Tháng'
    },
    {
        value: 'package',
        label: 'Liệu trình'
    },
]

export const LIST_SEX = [
    {
        value: 'male',
        label: 'Nam'
    },
    {
        value: 'female',
        label: 'Nữ'
    },
    {
        value: 'other',
        label: 'Khác'
    },
]

export const STATUS_SERVICES = [
    {
        value: 'doing',
        label: 'Đang thực hiện'
    },
    {
        value: 'completed',
        label: 'Đã hoàn thành'
    },
    {
        value: 'cancelled',
        label: 'Huỷ dịch vụ'
    },

]

export const STATUS_USAGE = [
    {
        value: 'valid',
        label: 'Còn hạn'
    },
    {
        value: 'expired',
        label: 'Hết hiệu lực'
    },
]

export const LIST_UNITS = [
    {
        value: 'Lo',
        label: 'Lọ'
    },
    {
        value: 'chiec',
        label: 'Chiếc'
    },
    {
        value: 'Chai',
        label: 'Chai'
    },
    {
        value: 'Cai',
        label: 'Cái'
    },
    {
        value: 'Hop',
        label: 'Hộp'
    },
    {
        value: 'ml',
        label: 'ml'
    },
    {
        value: 'Kg',
        label: 'Kg'
    },
    {
        value: 'Gam',
        label: 'Gram'
    },
    {
        value: 'Goi',
        label: 'Gói'
    },
    {
        value: 'Bo',
        label: 'Bộ'
    },
    {
        value: 'Cuon',
        label: 'Cuộn'
    },
    {
        value: 'Met',
        label: 'Mét'
    },
    {
        value: 'Ong',
        label: 'Ống'
    },
    {
        value: 'Tuyp',
        label: 'Tuýp'
    },
    {
        value: 'Khac',
        label: 'Khác'
    },
    {
        value: 'buoi',
        label: 'Buổi'
    },
    {
        value: 'lieutrinh',
        label: 'Liệu trình'
    },
    {
        value: 'soi',
        label: 'Sợi'
    },
    {
        value: 'tui',
        label: 'Túi'
    },
    
]

export const TYPE_EXPORT = [
    {
        value: 'sale',
        label: 'Xuất bán hàng'
    },
    {
        value: 'internal_use',
        label: 'Xuất sử dụng'
    }
]

export const TYPE_METHOD_SUPPORT = [
    {
        value: 'call',
        label: 'Điện thoại'
    },
    {
        value: 'zalo',
        label: 'Zalo'
    },

]

export const TYPE_RESULT_SUPPORT = [
    {
        value: 'successful',
        label: 'Đã phản hồi'
    },
    {
        value: 'no_response',
        label: 'Không phản hồi'
    },
    {
        value: 'failed',
        label: 'Không liên lạc được'
    },
];

export const PAYMENT_METHOD = [
    {
        value: 'cash',
        label: 'Tiền mặt'
    },
    {
        value: 'transfer',
        label: 'Chuyển khoản'
    }
]

export const LIST_YEAR = [
    {
        label: '2025',
        value: 2025,
    },
    {
        label: '2026',
        value: 2026,
    },
    {
        label: '2027',
        value: 2027,
    },
    {
        label: '2028',
        value: 2028,
    },
    {
        label: '2029',
        value: 2029,
    },
    {
        label: '2030',
        value: 2030,
    },
]